import { Action } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { PagesState } from '../../../../../../core/features/store/base-feature-state';
import { loaderReducer } from '../../../../../../core/state/utils/loader';
import { News, NewsPage } from '../../model';
import { NewsActions } from '../actions';
import { NewsActionTypes } from '../actions/news.action';
import { NEWS } from '../news-state';

export const initialState: PagesState<StateUtils.LoaderState<NewsPage>> = {};
export const NewsPageInitialState: NewsPage = undefined;

export function reducer(state = initialState, action: Action): PagesState<StateUtils.LoaderState<NewsPage>> {
  switch (action.type) {
    case NewsActionTypes.LoadNews:
    case NewsActionTypes.LoadNewsFail:
    case NewsActionTypes.LoadNewsSuccess: {
      const _action = <NewsActions.LoadNews>action;
      const count: string = _action.count;
      const loaderState = loaderReducer<NewsPage>(NEWS, NewsIdsReducer)(undefined, _action);
      return {
        ...state,
        [count]: {
          ...loaderState,
        },
      };
    }
    default:
      return state;
  }
}

export function NewsIdsReducer(state = NewsPageInitialState, action: Action): NewsPage {
  switch (action.type) {
    case NewsActionTypes.LoadNewsSuccess: {
      const _action = <NewsActions.LoadNewsSuccess>action;
      const payload: News[] = _action.payload;

      return {
        lastUpdateTime: new Date().toISOString(),
        ids: payload?.map((news) => news?.id),
      };
    }
    default: {
      return state;
    }
  }
}
